import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export function useLoginRedirect() {
  const navigate = useNavigate();

  const buildLoginUrl = React.useCallback((token?: string | null): string => {
    const buildUrl = (companyId?: unknown, creditId?: unknown): string => {
      if (!companyId) return "/login";
      const qs = new URLSearchParams();
      if (creditId) qs.set("creditId", String(creditId));
      qs.set("companyId", String(companyId));
      return `/login?${qs.toString()}`;
    };

    let loginUrl = "/login";
    try {
      if (token) {
        const decoded = jwtDecode(token) as {
          creditID?: number;
          creditId?: number;
          companyID?: number;
          companyId?: number;
        };
        const creditId = decoded?.creditID ?? decoded?.creditId;
        const companyId = decoded?.companyID ?? decoded?.companyId;
        loginUrl = buildUrl(companyId, creditId);
      }
    } catch {}

    if (loginUrl === "/login") {
      const raw = Cookies.get("portalLoginParams");
      if (raw) {
        try {
          const { creditId, companyId } = JSON.parse(raw);
          loginUrl = buildUrl(companyId, creditId);
        } catch {}
      }
    }

    return loginUrl;
  }, []);

  const redirectToLogin = React.useCallback(
    (options?: { replace?: boolean; token?: string | null }) => {
      const { replace = false, token } = options || {};
      const url = buildLoginUrl(token);
      navigate(url, { replace });
    },
    [buildLoginUrl, navigate],
  );

  return { buildLoginUrl, redirectToLogin };
}
